<template>
  <div class="nv_all">
    <div class="nv_left"></div>
    <div class="nv_mid">
      <b-navbar toggleable="xl" type="light" class="sticky-navbar">
        <div class="ml-auto nav-image-container" style="margin-right: 110px;">
          <b-img :src="require('@/assets/logoacon.png')" alt="Image 1" class="nav-image"></b-img>
        </div>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav v-model="navCollapsed">
          <b-navbar-nav class="lll">
            <router-link to="/" class="nav-link" active-class="active-nav-item" exact @click.native="closeNav">
              <div>Home</div>
            </router-link>
            <router-link to="/about" class="nav-link" active-class="active-nav-item" @click.native="closeNav">
              About DDM
            </router-link>
            <router-link to="/ecosystem" class="nav-link" active-class="active-nav-item" @click.native="closeNav">
              Ecosystem
            </router-link>
            <b-nav-item-dropdown text="Solutions" right>
              <router-link to="/in-hospital" class="dropdown-item" active-class="active-nav-item" @click.native="closeNav">
                In-Patient
              </router-link>
              <router-link to="/out-hospital" class="dropdown-item" active-class="active-nav-item" @click.native="closeNav">
                Out-Patient
              </router-link>
            </b-nav-item-dropdown>
            <router-link to="/about-us" class="nav-link" active-class="active-nav-item" @click.native="closeNav">
              About us
            </router-link>
            <router-link to="/Support" class="nav-link" active-class="active-nav-item" @click.native="closeNav">
              Support
            </router-link>
            <div class="la" style="margin-left: 20px;"> 
              <b-img :src="require('@/assets/nbar_earth.svg')" alt="Image 1" class="navearth"></b-img>
              <b-nav-item-dropdown text="EN" right>
                <b-dropdown-item class="d1">EN</b-dropdown-item>
              </b-nav-item-dropdown>
            </div>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
    <div class="nv_right"></div>
  </div>
</template>

<script>
export default {
  name: "NavbarPart",
  data() {
    return {
      navCollapsed: false
    };
  },
  methods: {
    closeNav() {
      this.navCollapsed = false;
    }
  }
};
</script>

<style scoped>
.nv_all {
  display: grid;
  grid-template-columns: 1fr 1200px 1fr; /* 定义三列：左、中、右 */
  gap: 0; /* 去掉列间距 */
}

.sticky-navbar {
  height: 80px;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 1000;
  background-color: white;
  box-shadow: 0 2px 5px rgb(255, 255, 255);
}

.navbar-collapse {
  display: flex;
  align-items: center;
  width: 100%;
}

.lll {
  display: flex;
  align-items: center;
  justify-content: space-around; /* 均匀分布导航项 */
  width: 100%;
  font-size: 20px;
  font-family: 'Arial', sans-serif;
  --bs-nav-link-color: #333333;
}

.lll .nav-link,
.lll .dropdown-item {
  white-space: nowrap; /* 防止换行 */
}

.lll .nav-link:hover {
  color: #007EFF;
}

.lll .dropdown-item {
  --bs-nav-link-hover-color: #007EFF;
}

.la {
  display: flex;
  align-items: center;
}

.link1 {
  color: #007bff;
}

.d1, .d2 {
  --bs-dropdown-link-color: #333333;
  text-align: left;
  font-size: 20px;
  font-family: 'Arial', sans-serif;
  font-weight: bold;
  --bs-dropdown-link-hover-color: #007EFF;
}

.nav-image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.nav-image {
  max-height: 60px;
}

.aconimg {
  margin-top: 327px;
  margin-left: 472%;
}

.active-nav-item {
  color: #007bff !important;
}

/* 添加媒体查询以调整导航栏在小屏幕上的样式 */
@media (max-width: 1200px) {
  .nav-image-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    margin-left: 0;
  }
  .navbar-collapse[data-v-41458b80] {
    display: flex;
    align-items: flex-start;
    width: auto;
    height: 400px;
    background: #FFFFFF;
  }
  .lll {
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
  }

  .lll .nav-link {
    margin-right: 0;
    margin-bottom: 10px;
  }

  .lll .dropdown-item {
    margin-bottom: 10px;
  }

  .la {
    margin-left: 0;
    display: flex;
    align-items: flex-start;
    align-items: center;
    align-content: center;
    justify-content: center;
  }
}
</style>